import {
  CustomFieldFilterColumn,
  useGetOrganisationCustomFieldsQuery,
} from 'src/graphql/generated';
import { useIsFeatureEnabled } from 'src/hooks';
import { FeatureFlag } from '../../../types';

export const useSpeakUpCustomFields = () => {
  const customFieldsEnabled = useIsFeatureEnabled(FeatureFlag.CUSTOM_FIELDS);
  const { data: customFieldsData } = useGetOrganisationCustomFieldsQuery(
    {
      input: {
        filters: [{ column: CustomFieldFilterColumn.Status, value: 'ACTIVE' }],
      },
    },
    { enabled: customFieldsEnabled },
  );
  const allCustomFields =
    customFieldsData?.getOrganisationCustomFields?.customFields ?? [];

  return { customFieldsEnabled, allCustomFields };
};
